import createIcon from '../../createIcon';

/**
 * @component @name Flaky
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjA1IDE3LjU4TDE0LjA0IDE3LjU5TDExLjY0IDE1LjE5TDEyLjcgMTQuMTNMMTQuMDUgMTUuNDhMMTYuNTQgMTNMMTcuNiAxNC4wNkwxNC4wNiAxNy42TDE0LjA1IDE3LjU4Wk0xMiAyQzYuNSAyIDIgNi41IDIgMTJDMiAxNy41IDYuNSAyMiAxMiAyMkMxNy41IDIyIDIyIDE3LjUgMjIgMTJDMjIgNi41IDE3LjUgMiAxMiAyWk03LjM0IDYuMjhMOC43NSA3LjY5TDEwLjE2IDYuMjhMMTEuMjIgNy4zNEw5LjgxIDguNzVMMTEuMjIgMTAuMTZMMTAuMTYgMTEuMjJMOC43NSA5LjgxTDcuMzQgMTEuMjJMNi4yOCAxMC4xNkw3LjY5IDguNzVMNi4yOCA3LjM0TDcuMzQgNi4yOFpNMTIgMjBDOS44IDIwIDcuOCAxOS4xIDYuMyAxNy43TDE3LjcgNi4zQzE5LjEgNy44IDIwIDkuOCAyMCAxMkMyMCAxNi40IDE2LjQgMjAgMTIgMjBaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Flaky = createIcon('Flaky', [
  [
    'path',
    {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.05 17.58L14.04 17.59L11.64 15.19L12.7 14.13L14.05 15.48L16.54 13L17.6 14.06L14.06 17.6L14.05 17.58ZM12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM7.34 6.28L8.75 7.69L10.16 6.28L11.22 7.34L9.81 8.75L11.22 10.16L10.16 11.22L8.75 9.81L7.34 11.22L6.28 10.16L7.69 8.75L6.28 7.34L7.34 6.28ZM12 20C9.8 20 7.8 19.1 6.3 17.7L17.7 6.3C19.1 7.8 20 9.8 20 12C20 16.4 16.4 20 12 20Z',
      key: '15fy5q',
    },
  ],
]);

export default Flaky;
